import {
  isDigitalSignatureField,
  SignatureResponse,
} from "@smart/bridge-types-basic";

import { DigitalSignatureField } from "./digital-signature-field";
import { ElectronicSignatureField } from "./electronic-signature-field";
import { fieldName } from "../../../hooks";
import { FieldGroup } from "../field-group";
import { Label } from "../label";
import { FieldProps, FieldWrapper } from "../wrapper";

export * from "./digital-signature-field";
export * from "./electronic-signature-field";

export const SignatureField = ({
  field,
  index,
  value,
  error,
  loading,
  disabled,
  onChange,
  onBlur,
  selectedLanguage,
}: FieldProps<
  HTMLCanvasElement | HTMLInputElement,
  SignatureResponse | null
>) => {
  const id = fieldName({ field, index });
  const errorId = fieldName({ field, index, suffix: "error" });

  const isDigital = isDigitalSignatureField(field);

  return (
    <FieldWrapper disabled={disabled} isLoading={loading}>
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
        message={error ?? undefined}
        messageId={errorId}
      >
        {isDigital ? (
          <DigitalSignatureField selectedLanguage={selectedLanguage} />
        ) : (
          <ElectronicSignatureField
            id={id}
            label={field.label}
            value={value}
            disabled={disabled}
            onChange={onChange}
            onBlur={onBlur}
            selectedLanguage={selectedLanguage}
          />
        )}
      </FieldGroup>
    </FieldWrapper>
  );
};
